import { faArrowCircleLeft, faPlus } from '@fortawesome/free-solid-svg-icons'
import React from 'react'
import { Button } from 'react-bootstrap'
import { Icon } from './Icon'
import { useNavigate } from 'react-router-dom';

export function BackButton() {
  const goTo = useNavigate();
  return (
    <Button
      onClick={() => goTo(-1)}
      variant="secondary"
      className="mt-5 fw-bold"
      aria-label="Go back to previous page"
    >
      <Icon icon={faArrowCircleLeft} aria-hidden="true" /> Back
    </Button>
  )
}

export const NavButton = ({ path }: { path: string }) => {
  const goTo = useNavigate();

  return path ? (
    <Button
      onClick={() => goTo(path)}
      variant="success"
      size="sm"
      className="fw-bold"
      aria-label="Add new item"
      style={{ whiteSpace: 'nowrap' }}
    >
      <Icon icon={faPlus} aria-hidden="true" /> <span className="d-none d-sm-inline">Add New</span>
    </Button>
  ) : null;
}
